function setupFormEmbedListener(formEmbed) {
  const shadowRoot = formEmbed.shadowRoot;

  const productTitle = document.querySelector(
    "#contact-form-equipment-submit-offer__dynamic-value"
  ).dataset.dynamicProductTitle;

  const productInterestInput = shadowRoot.querySelector(
    '[id="custom#interested_in_product"]'
  );

  // Hide parent elements and set dynamic product interest value
  productInterestInput.parentElement.style.display = "none";
  productInterestInput.setAttribute("value", productTitle);
  productInterestInput.dispatchEvent(new Event("input", { bubbles: true }));

  // Email subscribe formatting
  const checkboxContainer = shadowRoot.querySelector("fieldset");
  if (checkboxContainer) {
    const checkboxLabel = checkboxContainer.querySelector("legend");
    checkboxLabel.style.display = "none";
    const checkboxInput = checkboxContainer.querySelector("input");
    // Use different methods to set the input to checked and set value to subscribed
    // checkboxInput.setAttribute("value", "Subscribed");
    checkboxInput.checked = true;
    checkboxInput.setAttribute("checked", "true");
    checkboxInput.dispatchEvent(new Event("input", { bubbles: true }));
    checkboxInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
  // Money formatting function
  const offerInput = shadowRoot.querySelector('[id="custom#your_offer"]');
  if (offerInput) {
    moneyInputFormatting(offerInput);
  }
}

function moneyInputFormatting(offerInput) {
  offerInput.addEventListener("input", function (e) {
    // Remove any characters that aren't digits
    let value = e.target.value.replace(/[^0-9]/g, "");

    // Prevent Parsing empty string
    if (value === "") {
      e.target.value = "";
      return;
    }

    // Convert to a number and then format with commas
    value = parseInt(value, 10).toLocaleString();

    // Prepend with $ sign
    e.target.value = `$${value}`;
    offerInput.dispatchEvent(new Event("input", { bubbles: true }));
  });
}

const observer = new MutationObserver((mutationsList, observer) => {
  const formEmbed = document.querySelector("form-embed");
  if (formEmbed) {
    setupFormEmbedListener(formEmbed);
    // Stop observing once the element is found
    observer.disconnect();
  }
});

// Start observing the document body for added nodes
observer.observe(document.body, { childList: true, subtree: true });
